import { motion } from "framer-motion";
import Layout from "@/components/Layout";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import aboutHero from "@/assets/about-hero.jpg";

const PrivacyDisclaimerPage = () => {
  return (
    <Layout>
      <SEO title="Privacy Policy & Disclaimer | Vaughan McLean" description="Read Vaughan McLean's privacy policy and legal disclaimer regarding the use of this website and the information provided." />
      <PageHero backgroundImage={aboutHero} title="Privacy Policy & Disclaimer" subtitle="Legal" />

      <section className="section-dark py-24">
        <div className="container mx-auto px-8 lg:px-16 max-w-3xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="font-heading text-3xl md:text-4xl font-light text-foreground mb-6">
              Privacy Policy
            </h2>
            <p className="text-muted-foreground font-body leading-relaxed mb-16">
              Vaughan McLean understands that your privacy is important. Our website does not collect
              any personal information about you unless you provide that information to us voluntarily,
              such as through our online contact form. We do not share any of this information with
              third parties unless the third party is under contract with us to improve and provide
              services associated with the site or as otherwise required by law.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h2 className="font-heading text-3xl md:text-4xl font-light text-foreground mb-6">
              Disclaimer
            </h2>
            <p className="text-muted-foreground font-body leading-relaxed">
              The purpose of our website is to provide general information about the firm and our
              practice areas. The information you obtain from this site is not legal advice. You should
              consult an attorney for individual advice regarding your unique situation. Contacting the
              firm or reading the materials on the site does not create an attorney-client relationship.
            </p>
          </motion.div>
        </div>
      </section>
    </Layout>
  );
};

export default PrivacyDisclaimerPage;
